const IMAGE_URL_KEYS = [
  'originalUrl',
  'original_url',
  'optimizedUrl',
  'optimized_url',
  'url',
  'mediumUrl',
  'medium_url',
  'largeUrl',
  'large_url',
  'smallUrl',
  'small_url',
  'thumbnailUrl',
  'thumbnail_url',
];

const getImageUrl = (value) => {
  if (!value) return '';
  if (typeof value === 'string') return value;
  if (typeof value !== 'object') return value.toString();

  const urlKey = IMAGE_URL_KEYS.find(key => typeof value[key] === 'string' && value[key] !== '');
  return urlKey ? value[urlKey] : '';
};

export default getImageUrl;
